<template>
  <mobile-responsive-shell title="Chèques">
    <div class="pay-m">
      <div class="pay-m-toolbar">
        <button type="button" class="btn btn-primary btn-sm" @click="$router.push({ name: 'mobile-payments-customers-create' })">
          <i class="bi bi-plus-square"></i> Créer
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="refresh">
          <i class="bi bi-arrow-clockwise"></i> Actualiser
        </button>
      </div>

      <p v-if="!payments || !payments.length" class="text-muted text-center py-4">Aucun paiement.</p>

      <article v-for="(payment, idx) in payments" :key="payment.reference || idx" class="pay-m-card">
        <header class="pay-m-head">
          <span class="pay-m-ref">{{ payment.reference }}</span>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="$router.push({ name: 'mobile-payments-customers-details', params: { reference: payment.reference } })"
          >
            <i class="bi bi-info-square"></i>
          </button>
        </header>
        <div class="pay-m-meta">
          <span v-if="payment.customer">{{ payment.customer.fullName }}</span>
          <span v-else>—</span>
          <span class="text-muted"> · {{ payment.date }}</span>
        </div>
        <div class="pay-m-stats">
          <div><span class="lbl">BL</span><span>{{ payment.sale ? payment.sale.reference : "—" }}</span></div>
          <div>
            <span class="lbl">M. facture</span>
            <span v-if="payment.sale && payment.sale.totalPriceTTC >= 0">{{ payment.sale.totalPriceTTC }}</span>
            <span v-else>—</span>
          </div>
          <div><span class="lbl">Mode</span><span class="text-primary">{{ payment.paymentMethod }}</span></div>
          <div><span class="lbl">Payé</span><span class="text-success fw-semibold">{{ fmt(payment.amount) }}</span></div>
          <div><span class="lbl">À régler</span><span class="text-danger">{{ fmt(payment.remainingAmount) }}</span></div>
        </div>
        <footer v-if="payment.user" class="pay-m-foot small text-muted">{{ payment.user.name }}</footer>
      </article>
    </div>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";

export default {
  name: "MobilePaymentsChecks",
  components: { MobileResponsiveShell },
  computed: {
    ...mapGetters("payment", { payments: "getAll" }),
  },
  mounted() {
    this.$store.dispatch("payment/getAll");
  },
  methods: {
    fmt(v) {
      if (v === undefined || v === null || v === "") return "—";
      const n = parseFloat(v);
      if (Number.isNaN(n)) return String(v);
      return n.toFixed(2);
    },
    async refresh() {
      await this.$store.dispatch("payment/getAll");
    },
  },
};
</script>

<style scoped>
.pay-m-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.pay-m-card {
  background: #fff;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  margin-bottom: 0.65rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.pay-m-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}
.pay-m-ref {
  font-weight: 700;
  font-size: 0.95rem;
  word-break: break-all;
}
.pay-m-meta {
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
}
.pay-m-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.35rem 0.75rem;
  font-size: 0.85rem;
}
.pay-m-stats .lbl {
  display: block;
  font-size: 0.65rem;
  text-transform: uppercase;
  color: #6c757d;
}
.pay-m-foot {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
}
</style>
